import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '@/shared/ui/LoadingSpinner.jsx';

/**
 * Inline preview for plain-text files. Fetches the content and renders it in a
 * <pre>, which works regardless of the server's Content-Disposition (an
 * <iframe> would download an octet-stream response instead of showing it).
 */
export function TextPreview({ url, className = '' }) {
  const { t } = useTranslation(['editor']);
  const [state, setState] = useState({ loading: true, text: '', error: false });

  useEffect(() => {
    if (!url) { setState({ loading: false, text: '', error: true }); return; }
    let cancelled = false;
    setState({ loading: true, text: '', error: false });
    fetch(url)
      .then((r) => { if (!r.ok) throw new Error('fetch failed'); return r.text(); })
      // Cap to keep huge files from freezing the tab.
      .then((text) => { if (!cancelled) setState({ loading: false, text: text.slice(0, 500_000), error: false }); })
      .catch(() => { if (!cancelled) setState({ loading: false, text: '', error: true }); });
    return () => { cancelled = true; };
  }, [url]);

  if (state.loading) {
    return <div className={`flex items-center justify-center ${className}`}><LoadingSpinner width={28} color="#999" /></div>;
  }
  if (state.error) {
    return <div className={`flex items-center justify-center text-sm text-muted-foreground ${className}`}>{t('editor:previewLoadFailed')}</div>;
  }
  return (
    <pre className={`overflow-auto whitespace-pre-wrap break-words p-4 text-xs leading-relaxed font-mono bg-muted/30 ${className}`}>
      {state.text}
    </pre>
  );
}
